import React, { useState, useContext, useCallback, useEffect } from 'react';
import _ from 'lodash';
// import { wizardProps } from '@xengage/gw-portals-wizard-react';
// import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
// import { useValidation } from '@xengage/gw-portals-validation-react';
// import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
// import { withRouter } from 'react-router-dom';
// import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { TableView, DataViewTitle, DataViewColumns, GenericColumn, DataViewPagination } from '@jutro/legacy/dataview';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

// import metadata from './PCTClassCodeFilterTableComponent.metadata.json5';
// import styles from '../../../pages/EquipmentBreakdown/EquipmentBreakdownPage.module.scss';

function PCTClassCodeFilterTableComponent(props) {
    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    // const { onValidate } = useValidation('RiskInformationComponent');
   //  const viewModelService = useContext(ViewModelServiceContext);
    // const modelVM = _.get(submissionVM, pathUpdated);

    const [industryData, setIndustryData] = useState([]);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(5);

    

    // modelVM.value.isValidationReq = true;
    
   
    const getIndustryData = useCallback(() => {
            const data = _.get(submissionVM,
                'lobData.consTraAndServLine.coverables.equipmentBreakdown.riskInformation.pctclassCodes.value', []);
                
            setIndustryData(data);
    
        }, [submissionVM])
    
    useEffect(() => {
        getIndustryData();
    }, [getIndustryData]);

    
    
    const handlePaginationChange = (newPage, newPageSize) => {
        setPage(newPage);
        setPageSize(newPageSize);
    };    
        
    const paginatedData = industryData.slice((page - 1) * pageSize, page * pageSize);

    
    return (
        <TableView data={paginatedData} id="table">
            <DataViewTitle title="Industry Data" />
            <DataViewColumns>
                <GenericColumn header="Description of Occupancy" id="descriptionOfOccupancy" path="descriptionOfOccupancy" />
                <GenericColumn header="IBC Code" id="ibcCode" path="ibCcode" />
                <GenericColumn header="Industry Category" id="industryCategory" path="industryCategory" />
            </DataViewColumns>
            <DataViewPagination
                onPaginationChange={handlePaginationChange}
                page={page}
                pageSize={pageSize}
                pageSizes={[5, 10, 20, 50]}
                totalItems={industryData.length}
            />
        </TableView>
        );
    }

export default PCTClassCodeFilterTableComponent;